<template>
  <van-popup v-model="showQuestionPopup">
    <p class="title">{{ data.title }}</p>
    <img v-if="data.url" :src="require(`../../../${data.url}`)" alt="" />
    <div class="content border-bottom-1px">
      {{ data.content }}
    </div>
    <!--文本为：我知道了-->
    <div class="btn-confirm" @click="showQuestionPopup = false">Tôi biết rồi</div>
  </van-popup>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      showQuestionPopup: false,
    };
  },
  methods: {
    show() {
      this.showQuestionPopup = true;
    },
  },
};
</script>

<style lang="less" scoped>
.van-popup {
  width: 89%;
  border-radius: 8px;
  z-index:999999!important;
  .title {
    height: 52px;
    line-height: 52px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  img {
    width: 100%;
    height: 170px;
    background: #e5e5e5;
  }
  .content {
    margin: 15px 15px 0 15px;
    padding-bottom: 15px;
    line-height: 20px;
  }
  .btn-confirm {
    height: 52px;
    line-height: 52px;
    // color: var(--theme-color);
    font-size: 15px;
    text-align: center;
  }
}
</style>
